import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsApp = () => {
  return (
    <div className="fixed bottom-6 left-6 z-50">
      <a href="https://wa.me/9959303873"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black hover:bg-green-600 text-white p-4 rounded-full shadow-lg flex items-center justify-center">
        <FaWhatsapp size={24} />
      </a>
    </div>
  );
};

export default WhatsApp;
